import { render, staticRenderFns } from "./InsuranceUpdateRequestFormComponent.vue?vue&type=template&id=4c28647a&scoped=true"
import script from "./InsuranceUpdateRequestFormComponent.vue?vue&type=script&lang=ts"
export * from "./InsuranceUpdateRequestFormComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28647a",
  null
  
)

export default component.exports